const Divider = () => (
  <div
    style={ {
      height:  '95px',
      width: '2px',
      backgroundColor: '#F6F6F6',
    } }
  />
);

export default Divider;
